module.exports = __webpack_public_path__ + "static/img/import.700cc076.png";